import { asyncRouterMap, constantRouterMap } from "@/config/router.config"
import {loadAnonPages} from '../../api/api'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = -1
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.indexOf(permission[i])
      if (flag >= 0) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.indexOf(roles.id)
  } else {
    return true
  }
}

const permission = {
  namespace: true, // 设置命名空间
  state: {
    routers: constantRouterMap,
    addRouters: [],
    anonPages: null
  },
  mutations: {
    SET_ROUTERS: (state, data) => {
      state.addRouters = data
      state.routers = constantRouterMap.concat(data)
      console.log('-----mutations---SET_ROUTERS----', data)
    },
    SET_ANON_PAGES: (state, data) => {
      state.anonPages = data
      state.routers = constantRouterMap.concat()
      console.log('-----mutations---SET_ANONS----', data)
    }
  },
  actions: {
    // 动态添加主界面路由，需要缓存
    UpdateAppRouter({ commit }, routes) {
      return new Promise(resolve => {
        //const [ roles ] = routes.constRoutes
        let routelist = routes.constRoutes;
        commit('SET_ROUTERS', routelist)
        resolve()
      })
    },
    loadAnonList({commit}) {
      console.log('loadAnonPages')
      return new Promise((resolve, reject) => {
        console.log('send request')
        loadAnonPages().then(res => {
          console.log(res)
          if(res.result) {
            commit('SET_ANON_PAGES', res.result)
            resolve(res)
          }
          else {
            reject(res)
          }
        })
      })
    }
  }
}

export default permission